import React from 'react';
import './ProjectTimeDay.scss';

const GroupDay = ({day}) => {
  return <div className='project-time-day'>{day}</div>;
};

export default GroupDay;
